import { render, staticRenderFns } from "./BasicInfo.vue?vue&type=template&id=7ef151d8"
import script from "./BasicInfo.vue?vue&type=script&lang=js"
export * from "./BasicInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/stage.cashnow.d-resources.com/releases/67404460/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ef151d8')) {
      api.createRecord('7ef151d8', component.options)
    } else {
      api.reload('7ef151d8', component.options)
    }
    module.hot.accept("./BasicInfo.vue?vue&type=template&id=7ef151d8", function () {
      api.rerender('7ef151d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/accounts/view/BasicInfo.vue"
export default component.exports